import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { OrderClient } from "src/app/core/entities/orderClient";
import { InitProvider } from "src/app/core/services/init-provider";
import { PedidoService } from "src/app/core/services/pedido-service";
import { SecurityService } from "src/app/core/services/security-service";
import { UsuarioService } from "src/app/core/services/usuario-service";

@Injectable({
  providedIn: "root",
})
export class NewOrderService {
  constructor(
    private pedidoService: PedidoService,
    private usuarioService: UsuarioService,
    private initProvider: InitProvider,
    private securityService: SecurityService
  ) { }

  public automaticOrderSelection(): Observable<boolean> {
   // console.log(this.initProvider.inicializaPedido)   
   // console.log(this.initProvider)

    const iniciaPedidoSel = this.initProvider.inicializaPedido
    return new Observable((observer) => {
     // console.log(this.initProvider)
     // console.log(this.initProvider.inicializaPedido)

      if (iniciaPedidoSel) {
       // console.log(this.initProvider)
        //verifica se está logada
        if (this.securityService.hasToken()) {
         // console.log(this.pedidoService.pedido)

          // verifica se não há pedido selecionado
          if (this.pedidoService.pedido == null) {

           // console.log(this.initProvider)
            // verifica o número de filiais
            let branches = this.initProvider.filiais;
            if (branches.length === 1) {
             // console.log(this.initProvider)

              // verifica o numero de clientes
              this.usuarioService.getClientes(
                { busca: "%", id_usuario: this.initProvider.usuario.id },
                async (clients) => {
                 // console.log(clients)
                  if (clients.length === 1) {

                    (await this.getTables(clients[0], branches[0])).subscribe(
                      (data: any) => {
                        if (data.tabela_preco.length === 1) {
                         // console.log(this.initProvider)

                          // verifica os tipos de pedido
                          clients[0].idEnderecoErp = data.enderecos[0].id
                          this.usuarioService.getPedidoTipos((orderTypes) => {
                            if (orderTypes.length == 1) {

                              this.selectOrCreateOrder(
                                clients[0],
                                branches[0],
                                data.tabela_preco[0],
                                orderTypes[0]
                              ).subscribe(
                                (res) => {
                                 // console.log(res)
                                  this.pedidoService.allowDelete = false
                                  observer.next(res);
                                },
                                (error) => {
                                  observer.next(false)
                                  this.pedidoService.allowDelete = true
                                }
                              );
                            } else {
                              observer.next(false)
                              this.pedidoService.allowDelete = true;
                            }
                          });
                        } else {
                          observer.next(false)
                          this.pedidoService.allowDelete = true;
                        }
                      }
                    );
                  } else {
                    observer.next(false)
                    this.pedidoService.allowDelete = true;
                  }
                }
              );
            } else {
              observer.next(false)
              this.pedidoService.allowDelete = true;
            }
          } else {
            observer.next(false)
            this.pedidoService.allowDelete = true;
          }
        } else {
          observer.next(false)
          this.pedidoService.allowDelete = true;
        }
      } else {
        observer.next(false)
        this.pedidoService.allowDelete = true;
      }
    });
  }


  private async getTables(branch, client): Promise<Observable<any[]>> {
    try {
      let id = await this.getIdFromClientes();
      return new Observable((observer) => {
        this.usuarioService.getClientesId({ id_cliente: id }, (data) => {
          observer.next(data);
          //// console.log(userTables[0].fn_cliente_id.content.tabela_preco[0])
        });
      });
    } catch (error) {
      // Lida com erros, se necessário
    }
  }

  private getIdFromClientes(): Promise<number> {
    return new Promise((resolve, reject) => {
      this.usuarioService.getClientes({ busca: "%" }, (e) => {
        if (e && e[0] && e[0].id) {
          resolve(e[0].id);
        } else {
          reject(new Error("Erro ao obter o ID do cliente"));
        }
      });
    });
  }

  private selectOrCreateOrder(
    client,
    branch,
    table,
    orderType
  ): Observable<boolean> {
    return new Observable((observer) => {
      // verifica se existe pedido em digitação
      this.pedidoService.listaPedido(
        { page: 0 },
        (orders) => {
          // caso exista, seleciona o primeiro
          if (orders.content.length === 1) {

            this.pedidoService.getPedidoId(orders.content[0].id, (e) => {
              this.pedidoService.select(e);
            });
            this.pedidoService.select(orders.content[0]);
            return observer.next(true);
          } else if (orders.content.length > 1){
            return null
          }         
          else {
            return this.newOrder(client, branch, table, orderType, observer);
          }
        },
        false
      );
    });
  }

  private newOrder(client, branch, table, orderType, observer): void {
    let pedidoClientes: OrderClient[] = [
      {
        idEnderecoErp: client.idEnderecoErp,
        cliente: client.id,
        quantidade: 0,
        subtotal: 0,
        impostos: 0,
        acrescimo: 0,
        acrescimoPercent: 0,
        desconto: 0,
        descontoPercent: 0,
        total: 0,
      },
    ];

    let formPedido = {
      clientes: pedidoClientes,
      filial: branch.id,
      tabela: table.id,
      tipo: orderType.id,
      dataEntrega: "",
    };
    this.pedidoService.abrir(
      formPedido,
      (resp) => {
        this.pedidoService.select(resp);
        observer.next(true);
      },
      (error) => {
        console.error(error);
        observer.next(false);
      }
    );
  }
}
